module.exports = __webpack_public_path__ + "static/caracteristicas-f5f1ba271b583031e89e5fd53501d57a.png";